DS.JSONTransforms['raw'] = {
  serialize: function(value) {
    return value;
  },

  deserialize: function(value) {
    return value;
  }
};

Pegasus.ApplicationSerializer = DS.JSONSerializer.extend({
});

Pegasus.FixtureAdapter = DS.FixtureAdapter.extend({
  didFindAll: function(store, type, payload) {
    Pegasus.lookupController('launchPlatform').didRetrieve(type);
    this._super(store, type, payload);
  }
});

Pegasus.Store = DS.Store.extend({
  revision: 12,
  adapter: Pegasus.FixtureAdapter.create()
});
